import script from "./VCollapseContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./VCollapseContent.vue?vue&type=script&lang=ts&setup=true"

import "./VCollapseContent.vue?vue&type=style&index=0&id=568362cc&lang=sass"

const __exports__ = script;

export default __exports__